import React from 'react';
import { Hero } from '../components/Hero';
import { PainSection } from '../components/PainSection';
import { IntroSection } from '../components/IntroSection';
import { TomosSection } from '../components/TomosSection';
import { BonosSection } from '../components/BonosSection';
import { UsesSection } from '../components/UsesSection';
import { ComparisonSection } from '../components/ComparisonSection';
import { AudienceSection } from '../components/AudienceSection';
import { PricingSection } from '../components/PricingSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { WhyTodaySection } from '../components/WhyTodaySection';
import { FaqSection } from '../components/FaqSection';
import { FinalCtaSection } from '../components/FinalCtaSection';
import { SiteFooter } from '../components/SiteFooter';
import { StickyCta } from '../components/StickyCta';
import { PurchaseToast } from '../components/PurchaseToast';
interface LandingProps {
  barraCompraFija?: boolean;
  avisosDeCompra?: boolean;
}
export function Landing({
  barraCompraFija = true,
  avisosDeCompra = true
}: LandingProps) {
  return <div className="w-full bg-cream" data-id="element-214" data-mp="3tes03yzzenqh">
      <Hero data-id="element-215" data-mp="3peq86hk1t8oe" />
      <main data-id="element-216" data-mp="3pegjcxaqp7ka">
        <PainSection data-id="element-217" data-mp="3pdyc75mjh8xl" />
        <IntroSection data-id="element-218" data-mp="3pfj74wcrmtvz" />
        <TomosSection data-id="element-219" data-mp="3pgua4tydzxm1" />
        <BonosSection data-id="element-220" data-mp="3kfn3wzbw76hh" />
        <UsesSection data-id="element-221" data-mp="3kgeyq7xo106p" />
        <ComparisonSection data-id="element-222" data-mp="3kgyepj3r9ei3" />
        <AudienceSection data-id="element-223" data-mp="3khq3ob2ukdze" />
        <PricingSection data-id="element-224" data-mp="l09wc9h2puco" />
        <TestimonialsSection data-id="element-225" data-mp="kzgmv0qqcqqu" />
        <WhyTodaySection data-id="element-226" data-mp="kzqeesrfb5yn" />
        <FaqSection data-id="element-227" data-mp="gywra1lt1v6t" />
        <FinalCtaSection data-id="element-228" data-mp="gyen8iswicoc" />
      </main>
      <SiteFooter data-id="element-229" data-mp="gzg8fg3msfjs" />
      {barraCompraFija && <StickyCta data-id="element-230" data-mp="c87y8huh8q5k" />}
      {avisosDeCompra && <PurchaseToast data-id="element-231" data-mp="c76d1kjqyna4" />}
    </div>;
}